export default "/app/global-wrapper-client/static/8bb0aa105cd72d78a14238ae49b191fc.woff";